/**
 * Every wording a reasonless fetch abort has been seen to produce. Not one per browser: Chrome
 * emits the first and third interchangeably, interleaved within a single session.
 */
const CANCELLED_OPERATION_MESSAGES = [
  'signal is aborted without reason',
  'The operation was aborted.',
  'The user aborted a request.',
]

interface IsCancelledOperationErrorParams {
  source: string
  message: string
}

/**
 * True when RUM auto-captured the abort Apollo raises cancelling a superseded request — intended
 * behaviour that never reaches the user, and not gated on the tab being backgrounded because it is
 * always app-initiated. The rate stays visible as `@resource.status_code:0`.
 *
 * Matched exactly and only for a non-`custom` source: an abort naming a reason, or one the app
 * reported through `logError`, is a deliberate signal and must survive.
 */
export const isCancelledOperationError = ({ source, message }: IsCancelledOperationErrorParams): boolean =>
  source !== 'custom' && CANCELLED_OPERATION_MESSAGES.includes(message)
